import { makeAutoObservable, runInAction } from "mobx";
import type { RootStore } from "./root.store";
import type { IInstance, IInstanceConfig } from "@/types/instance";

export class InstanceStore {
  instance: IInstance | null = null;
  config: IInstanceConfig | null = null;
  isLoading = false;
  error: string | null = null;

  private rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, { rootStore: false } as never, { autoBind: true });
  }

  get isPasswordAuthEnabled(): boolean {
    return this.config?.is_email_password_enabled ?? false;
  }

  get isMagicCodeEnabled(): boolean {
    return this.config?.is_magic_login_enabled ?? false;
  }

  get isGoogleEnabled(): boolean {
    return this.config?.is_google_enabled ?? false;
  }

  get isSAMLEnabled(): boolean {
    return this.config?.is_saml_enabled ?? false;
  }

  get isSignupEnabled(): boolean {
    return this.config?.enable_signup ?? false;
  }

  get isSmtpConfigured(): boolean {
    return this.config?.is_smtp_configured ?? false;
  }

  get isSetupDone(): boolean {
    return this.instance?.is_setup_done ?? false;
  }

  async fetchInstanceInfo(): Promise<void> {
    if (this.instance) return;
    this.isLoading = true;
    this.error = null;
    try {
      const { instance, config } = await this.rootStore.instanceService.getInstanceInfo();
      runInAction(() => {
        this.instance = instance;
        this.config = config;
      });
    } catch (err) {
      runInAction(() => {
        this.error = "instance.fetch_error";
      });
      throw err;
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }
}
